import React from 'react'
import {
  StyledTitle,
  StyledBorder
} from './index.styled'

const TitleComponent = ({ border = false, borderType = 'bottom-border', titleType = "first-title", children}) => (
  <React.Fragment>
    <StyledTitle className={titleType}>{children}</StyledTitle>
    {border && <StyledBorder borderType={borderType} />}
  </React.Fragment>
);

export default TitleComponent;